import React, { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
// protected route component
import ProtectedRoute from "./middleware/Auth/protectedRoute";
import LoaderModal from "./components/common/LoaderModal";
import PhoneVerification from "./components/authPage/phone.jsx"
import HomeDashboard from "./views/layout/HomeDashboard.jsx";
import UserDashboard from "./components/Dashboard/UserDashboard";
import MoilUserDashboard from "./components/Dashboard/moil_user_dashboard.jsx"
import Logout from "./components/Logout/logout";
import UserResumeForm from "./components/Resume/moil_user_resume";
import { useSelector, useDispatch } from "react-redux";
import UserResumeType from "./components/Resume/screens/moil_user_resume_type";
import WorkerProfile from "./components/Profile/newProfile";
import UserJobType from "./components/Resume/screens/moil_user_job_type";
import UserSKillsAndLicensing from "./components/Resume/screens/moil_user_license";
import UserEducation from "./components/Resume/screens/moil_user_education";
import UserWorkExperience from "./components/Resume/screens/moil_user_work";
import UserReference from "./components/Resume/screens/moil_user_reference";
import ProfilePhoto from "./components/Image";
import PublicJobDetails from "./components/Job/publicJobDetails.jsx"

import ProfileProtected from "./middleware/Auth/profileProtected";
import EmployeesJobCreated from "./components/Job/employees_view_job_created";
import EmployeeJobs from "./components/Job/jobs";
import UserMessages from "./components/Message/message";
import UserPreference from "./components/Resume/screens/moil_user_preference";
import SearchJobField from "./components/common/SearchBars/SearchJobField";
import PageTrackingHOC from "./middleware/Auth/pageTrackingHOC";
import Register from "./components/Register/index.jsx";
import Login from "./components/login/index.jsx";
import Forgot from "./components/authPage/Forgot";
import AuthPage from "./components/authPage";
import Reset from "./components/authPage/Reset"
import { AnalyticsProviderContext } from "./context/AnalyticsContext";
import Analytics from 'analytics';
import segmentPlugin from '@analytics/segment';
import NewUploadModal from "./components/common/upload/uploadModal";
import Resume from "./components/Resume/MyResume/Resume"
import UserMessagesUser from "./components/Message";
import UserJobDetails from "./components/Job/index"
import EmployerWorkerViewOriginal from "./components/Profile/EmployerProfile/employer_workerview_profile.jsx"
import { resume_step_jump_function } from "./Redux/ActionCreator.js";
import NotAvailable from "./components/common/not_available";
// import { startTokenRefreshInterval } from "./utils/auth-token/refreshToken";
import ProfileCreation from "./components/profile_creation/index.jsx";
// import NotFoundPage from "./components/error_page"
import ProfileSummary from "./components/profile_creation/pages/preview.jsx"

const UserResume = lazy(() => import("./components/Resume/screens/moil_user_resume"));
const UserPreviewDetails = lazy(() => import("./components/Resume/screens/moil_user_preview"));
// const EmployerProfileView = lazy(() => import("./components/Profile/worker_employerView_profile"))
const Sidebar = lazy(() => import("./components/sidebar/sidebar"));
// const Resume = lazy(() => import("./components/Resume/MyResume/Resume"));
// const UserJobDetails = lazy(() => import("./components/Job/index"));
// const EmployerWorkerViewOriginal = lazy(() => import("./components/Profile/EmployerProfile/employer_workerview_profile.jsx"));
const ShareProfile = lazy(() =>
  import("./components/shareProfile")
);
// const UserMessagesUser = lazy(() => import("./components/Message"));
const WorkerDecisionCard = lazy(() => import("./components/DecisionCard/workerDecisionCard"));
import DownloadResumeModal from "./components/Resume/DownloadResume"
import NotFoundPage from "./components/error_page/index.jsx";
import { ToastContainer, toast } from "react-toastify";
import QRCodeGenerator from "./components/QRcode/qrcode.jsx";
import SkillTest from "./components/skillTest/index.jsx";
import { dispatchT_Language } from "./Redux/ActionCreator.js";
// import EnhancedInterviewPracticeApp from "./components/test/newInterview"
import InterviewApp from "./components/test/index";
import CareerCoach from "./components/career-coach/pages/Dashboard";
// import  UploadResumeModal from "./components/common/upload_resume_modal"

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile_state = useSelector((prev) => prev.login);
  const lastPage = useSelector(e => e.lastPage);
  const userInfo = useSelector((e) => e.userInfo);
  let token = localStorage.getItem("token");
  // let [ value, setValue ] = useState(null);

  // setTimeout(() => {
  //   const combo = document.querySelector(".goog-te-combo");
  //   let value;
  //   if (combo) {
  //     value = combo.value;
  //     console.log("Selected language:", value);
  //   } else {
  //     console.error("Google Translate combo element not found");
  //   }
  // }, 100);

  useEffect(() => {
    let url = new URL(window.location.href);
    let lang = url.searchParams.get("lg");
    if (lang == "en") {
      console.log("called here after login");
      dispatch(dispatchT_Language("English"));
    } else if (lang === "es") {
      dispatch(dispatchT_Language("Spanish"));
    }
  }, [])

  // useEffect(() => {
  //   // Function to update language based on the combo's value.
  //   const updateLanguage = () => {
  //     const combo = document.querySelector(".goog-te-combo");
  //     if (combo) {
  //       const value = combo.value;
  //       console.log("language value", value);
  //       if (value === "en") {
  //         dispatch(dispatchT_Language("English"));
  //       } else if (value === "es") {
  //         dispatch(dispatchT_Language("Spanish"));
  //       }
  //     }
  //   };
  
  //   let comboObserver;
  
  //   // First, check if the combo element already exists.
  //   let combo = document.querySelector(".goog-te-combo");
  //   if (combo) {
  //     updateLanguage();
  //     // Observe attribute changes on the combo (specifically the "value" attribute)
  //     comboObserver = new MutationObserver(() => {
  //       updateLanguage();
  //     });
  //     comboObserver.observe(combo, { attributes: true, attributeFilter: ["value"] });
  //   } else {
  //     // If the element isn't available yet, observe the entire document body for DOM changes.
  //     const bodyObserver = new MutationObserver(() => {
  //       combo = document.querySelector(".goog-te-combo");
  //       if (combo) {
  //         updateLanguage();
  //         // Now that the element is available, start watching for its attribute changes.
  //         comboObserver = new MutationObserver(() => {
  //           updateLanguage();
  //         });
  //         comboObserver.observe(combo, { attributes: true, attributeFilter: ["value"] });
  //         // Stop observing the entire body once the element is found.
  //         bodyObserver.disconnect();
  //       }
  //     });
  //     bodyObserver.observe(document.body, { childList: true, subtree: true });
  //     // Clean up the body observer on unmount.
  //     return () => {
  //       bodyObserver.disconnect();
  //       if (comboObserver) comboObserver.disconnect();
  //     };
  //   }
  
  //   // Cleanup on unmount.
  //   return () => {
  //     if (comboObserver) {
  //       comboObserver.disconnect();
  //     }
  //   };
  // }, [dispatch, dispatchT_Language]);
  


  // useEffect(() => {
  //   let intervalId;

  //   if (profile_state.isAuthenticated) {
  //     // Start the token refresh interval
  //     intervalId = startTokenRefreshInterval();
  //   }

  //   // Cleanup function to clear the interval when the component unmounts
  //   return () => {
  //     if (intervalId) {
  //       clearInterval(intervalId);
  //     }
  //   };
  // }, [profile_state.isAuthenticated]);


  const analytics = Analytics({
    app: 'Moilapp',
    plugins: [
      segmentPlugin({
        writeKey: '5ohjq1GtYDnbs28HuF4kYpFRe6XHiJ2S',
      }),
    ],
  });

  analytics.page();

  const handlejump = (step) => {
    dispatch(resume_step_jump_function(step));
  }

  
   // useEffect to set user credentials cookie when userInfo changes
   useEffect(() => {
    if (userInfo && userInfo.user && profile_state.isAuthenticated) {
      // console.log("Setting cookie from userInfo:", userInfo.user);
      
      // Determine auth method based on available data
      let authMethod = userInfo.user.authType; // Default to password
      
      // Check if this is an OAuth login (typically OAuth users don't have password in userInfo)
      if (userInfo.user.authType) {
        authMethod = userInfo.user.authType;
      } else if (!userInfo.user.password && userInfo.user.email) {
        authMethod = "OAUTH";
      }
      
      setUserCredentialsCookie(userInfo.user, authMethod);
    }
  }, [userInfo, profile_state.isAuthenticated]);
  
  // Function to get cookie value
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      try {
        return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()));
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  // Function to set user credentials cookie for both OAuth and Password
  const setUserCredentialsCookie = (userData, authMethod) => {
    const userCredentials = {
      method: authMethod, // "OAUTH" or "PASSWORD"
      email: userData.email || userData.username || "",
      phone: userData.phone_number || "",
      authMethod: authMethod,
      userImage: userData.profile_pics || "",
      timestamp: new Date().toISOString()
    };
    
    // Set cookie with 30 days expiration
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    document.cookie = `moil_user_creds=${encodeURIComponent(JSON.stringify(userCredentials))}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  };
  


  // console.log("bool", bool);
  return (
    <AnalyticsProviderContext analytics={analytics}>
      <div className="app">
        <main className="content">
          <Suspense
            fallback={<LoaderModal text="Our AI is loading your data" />}
          >
            <Routes>
              <Route path="/" element={<Login />} />
              {/* <Route
                path="/profile/beta/*"
                element={
                  <ProfileProtected>
                    <PageTrackingHOC>
                      <EmployerProfileView />
                    </PageTrackingHOC>
                  </ProfileProtected>
                }
              /> */}
              <Route
                path="verify-phone"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <PhoneVerification />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-profile1"
                element={
                  // <ProtectedRoute>
                  <ProfileSummary />
                  // </ProtectedRoute>
                }
              ></Route>
              {/* User route start */}
              <Route
                path="/user"
                element={
                  // <ProtectedRoute>
                  <HomeDashboard />
                  // </ProtectedRoute>
                }
              >
                <Route
                  path="jobs"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <EmployeeJobs />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="messages"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <UserMessages />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="messages/:receiverId"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <UserMessagesUser />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="messages/:receiverId/decisionCard/:cardId"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <WorkerDecisionCard />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="profile/:profile_id"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <WorkerProfile />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                {/* New path added by BigSam  */}
                <Route
                  path="welcome"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <UserDashboard />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="dashboard"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <MoilUserDashboard />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="createProfile"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <UserResume />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path=":profile_id/share"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <ShareProfile />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="employer/profile/*"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <EmployerWorkerViewOriginal />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="job_preview/:jobName"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <UserJobDetails />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="available_jobs"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <EmployeesJobCreated />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="job/skillTest/:jobName"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <SkillTest />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="interview"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <InterviewApp />
                        {/* <EnhancedInterviewPracticeApp /> */}
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
              </Route>

              <Route
                path="career-coach"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <CareerCoach />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />

              {/* User route ends */}

              {/* General route start */}
              {token !== null ? (
                <Route
                  path="/jobs"
                  element={
                    // <ProtectedRoute>
                    <HomeDashboard />
                    // </ProtectedRoute>
                  }
                >
                  <Route path=":jobName" element={<UserJobDetails />} />
                </Route>
              ) : (
                <Route
                  path="jobs/:jobName"
                  element={
                    // <ProtectedRoute>
                    <PublicJobDetails />
                    // </ProtectedRoute>
                  }
                />
              )}
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/authenticate" element={<AuthPage />}>
                <Route path="forgot" index element={<Forgot />} />
                <Route path="reset" element={<Reset />} />
              </Route>
              <Route
                path="/user/jobs/search/:jobId"
                element={
                  <ProfileProtected>
                    <PageTrackingHOC>
                      <UserJobDetails />
                    </PageTrackingHOC>
                  </ProfileProtected>
                }
              />
              {/* <Route
                path="user/profile/update/personalInfo"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserPreference />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="user/profile/update/about"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserJobType handlejump={handlejump} />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />

              <Route
                path="user/profile/update/skills"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserSKillsAndLicensing />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />

              <Route
                path="user/profile/update/education"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserEducation />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="user/profile/update/experience"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserWorkExperience />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="user/profile/update/reference"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserReference />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="update/*"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <ProfilePhoto />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  // <ProtectedRoute>
                  <HomeDashboard />
                  // </ProtectedRoute>
                }
              >
                <Route
                  path="resume"
                  element={
                    <ProtectedRoute>
                      <PageTrackingHOC>
                        <Resume />
                      </PageTrackingHOC>
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route
                path="/logout"
                element={
                  <ProtectedRoute>
                    <Logout />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path="/generateCV"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserResumeType />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              /> */}
              {/* <Route
                path="/allCv"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserPreviewDetails />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              /> */}
              {/* <Route
                path="/payment"
                element={
                  <ProtectedRoute>
                    <StripeComponent />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/upload"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <NewUploadModal />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                  // UploadModal
                }
              />
              {/* <Route
                path="/resume/:cvID"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserPreviewDetails />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/form//*"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserResumeForm />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/form/:id/*"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <UserResumeForm />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="create-profile"
                element={
                  <ProtectedRoute>
                    <PageTrackingHOC>
                      <ProfileCreation />
                    </PageTrackingHOC>
                  </ProtectedRoute>
                }
              />

              <Route path="/moilQR/:profile_id" element={<QRCodeGenerator />} />
              <Route path="/unavailable" element={<NotAvailable />} />

              <Route path="/test" element={<SkillTest />} />

              {/* <Route path="/uploadss" element={<NewUploadModal />} /> */}

              {/* General route ends */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </main>
        <ToastContainer />
      </div>
    </AnalyticsProviderContext>
  );
}

export default App;
